import { PropertyMapper } from '../../decorators';

export class DeliveryStatus {
    @PropertyMapper()
    public id: number;

    @PropertyMapper()
    public name: string;
}
